export enum StcTransLineStatus {
    UnderArbeid = 20,
    BehandletKomplett = 40,
    KlarForEksport = 50,
    Eksportert = 60
}